var tmpl = require('./pic.ejs');
var style = require('./pic.css');

// 三张
// [{
//     "url": "\/\/p0.ifengimg.com\/508df9aec9e2a\/image\/2016\/10\/03\/14754740037931_1024_768.jpg",
//     "w": "1024",
//     "h": "768"
// }, {
//     "url": "\/\/p3.ifengimg.com\/508df9aec9e2a\/image\/2016\/10\/03\/14754740035256_1024_768.jpg",
//     "w": "1024",
//     "h": "768"
// }, {
//     "url": "\/\/p1.ifengimg.com\/508df9aec9e2a\/image\/2016\/10\/03\/14754740036965_1024_768.jpg",
//     "w": "1024",
//     "h": "768"
// }]index

//2张
// [{
//     "url": "\/\/p3.ifengimg.com\/508df9aec9e2a\/image\/2016\/10\/01\/14753070098693_690_387.jpg",
//     "w": "690",
//     "h": "387"
// }, {
//     "url": "\/\/p1.ifengimg.com\/508df9aec9e2a\/image\/2016\/10\/01\/14753070098360_690_1037.jpg",
//     "w": "690",
//     "h": "1037"
// }]

//一张
// [{
//     "url": "\/\/p0.ifengimg.com\/508df9aec9e2a\/image\/2016\/10\/03\/14754595534768_440_293.jpg",
//     "w": "440",
//     "h": "293"
// }]
function formatPictures (pics) {
            var item;
            var url = '//d.ifengimg.com/';
            var rat;
            for (var i = 0, iLen = pics.length; i < iLen; i++) {
                item = pics[i];
                if (pics.length == 1) {
                    rat = 'mw540_mh360/'
                } else if (pics.length == 2 || pics.length == 4) {
                    if (item.h / 1 > item.w / 1) {
                        rat = 'w266/';
                    } else {
                        rat = 'h266/';
                    }
                } else {
                    if (item.h / 1 > item.w / 1) {
                        rat = 'w170/';
                    } else {
                        rat = 'h170/';
                    }
                }
                item.url = item.url.replace(/^(?:https?:)?\/\//, '');
                item.purl = url + rat + item.url;
            }
            return pics;
        }

module.exports = function (picturesData,mid) {
	var picData = formatPictures(picturesData);
   return tmpl({picData,mid});
};




// WEBPACK FOOTER //
// /Users/zhujian/Desktop/code/live_system/live/modules/f.component.pic.pc/app/modules/pic/index.js